import React, { useEffect, useContext } from 'react'
import { Row, Col } from 'react-bootstrap'
import { LanguageContext, langConstant } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'
import "./Language.css"
import { Container, HeaderTitle } from '../Library'

function Language() {
    const langCx = useContext(LanguageContext)
    const notify = useContext(NotifyContext)
    const lang = langCx.lang.language
    const code = langCx.code

    const switchLanguage = (toLang) =>{
        langCx.setLanguage(toLang)
    }

    useEffect(()=>{
        setDocumentTitle("Language")
    },[])

    return (
        <Container id="language" topbarTitle={lang.lang}>
            <HeaderTitle
            title={lang.choose_lang}
            description={lang.choose_lang_desc}/>
            <Row>
                <Col lg={8}>
                    <LanguageItem 
                    title="English" 
                    isSelected={code === langConstant.EN ? true: false}
                    onClick={()=>switchLanguage(langConstant.EN)}/>
                    <LanguageItem 
                    title="ไทย" 
                    isSelected={code === langConstant.TH ? true: false}
                    onClick={()=>switchLanguage(langConstant.TH)}/>
                </Col>
            </Row>
        </Container>
    )
}

function LanguageItem(props){
    return(
        <div className="item"
        onClick={props.onClick}>
            <div>
                {props.title}
            </div>
            { props.isSelected ?
            <div className="icon">
                <FontAwesomeIcon icon={faCheck}/>
            </div>
            : null
            }
        </div>
    )
}

export default Language
